export default __webpack_public_path__ + "static/media/marker.f562ced4.svg";